/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Cost_Tokens_InputInputs */



/**
* | output |
* | --- |
* | "Input" |
*
* @param {Chat_Cost_Tokens_InputInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_cost_tokens_input = /** @type {((inputs?: Chat_Cost_Tokens_InputInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Cost_Tokens_InputInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eingabe")
	return /** @type {LocalizedString} */ ("Input")
});